import { NgModule } from '@angular/core';


@NgModule({
  declarations: [
    // GipUserFormComponent,
  //GipUserChangePwdFormComponent],
  ],
  imports: [
  ],
  exports: [
    // GipUserFormComponent,
  ],
})
export class UserModule { }
